import React from 'react';
import NavBar from '../NavBar/NavBar';
import { Routes } from 'react-router-dom';


const HeaderAndFooter = ({ children }) => {
  return (
    <div>
      <div className='wrapper'>        
        <NavBar/>

        <div style={{ padding:"20px"}}>
            
            {children}
           
      </div>
      </div>
    </div>
  );
};

export default HeaderAndFooter;